module.exports = __webpack_public_path__ + "img/王健.bb6663f5.jpg";